import type { FilesOptions, StateWithFilesOptions } from './reducer'

export const getFilesOptionsStatus = (
    state: StateWithFilesOptions,
): FilesOptions | undefined => state.filesOptions.options
